<template>
  <section class="show-case">
    <div v-if="new_products.length > 0" class="row mt-3">
      <div class="col col-md-2 col-lg-2">
        <img src="@/assets/svg/Ardunic Elements-09.svg" />
        <div class="text-center">
          <p class="h4 mt-3">New Products</p>
        </div>
      </div>
      <div class="col-1"></div>
      <div class="col col-md-9 col-lg-9 reduce py-2">
        <CardsSlider :data="new_products" />
      </div>
    </div>
    <div v-if="most_discounted.length > 0" class="row mt-3">
      <div class="col col-md-2 col-lg-2">
        <img src="@/assets/svg/Ardunic Elements-07.svg" />
        <div class="text-center">
          <p class="h4 mt-3">Offers</p>
        </div>
      </div>
      <div class="col-1"></div>
      <div class="col col-md-9 col-lg-9 reduce py-2">
        <CardsSlider :data="most_discounted" />
      </div>
    </div>
    <div v-if="deal_of_the_week.length > 0" class="row mt-3">
      <div class="col col-md-2 col-lg-2">
        <img src="@/assets/svg/Ardunic Elements-08.svg" />
        <div class="text-center">
          <p class="h4 mt-3">Top selling</p>
        </div>
      </div>
      <div class="col-1"></div>
      <div class="col col-md-9 col-lg-9 reduce py-2">
        <CardsSlider :data="deal_of_the_week" />
      </div>
    </div>
  </section>
</template>

<script>
import CardsSlider from "@/components/CardsSlider";
import axios from "axios";
export default {
  components: {
    CardsSlider,
  },
  data() {
    return {
      most_discounted: [],
      deal_of_the_week: [],
      new_products: [],
    };
  },
  created() {
    this.getMostDiscounted();
    this.getDealsOfTheWeek();
    this.getNewProducts();
  },
  methods: {
    getMostDiscounted() {
      axios
        .get("https://api.ardunic.com/v1/most_discounted?p=1&s=10")
        .then((res) => (this.most_discounted = res.data.data));
    },
    getDealsOfTheWeek() {
      axios
        .get("https://api.ardunic.com/v1/deal_of_the_week?p=1&s=10")
        .then((res) => (this.deal_of_the_week = res.data.data));
    },
    getNewProducts() {
      axios
        .get("https://api.ardunic.com/v1/new_products?p=1&s=10")
        .then((res) => (this.new_products = res.data.data));
    },
  },
};
</script>

<style>
.show-case {
  margin-top: 110px;
  margin-right: 60px;
  margin-left: 60px;
}

.reduce {
  border-radius: 20px;
  border: 1px solid #c1c2c5;
}
</style>
